var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Hint from '@storeblocks/hint';
import { CheckboxBase, CheckboxGroupLabel } from './styled';
import Single from './single';
import Attention from './attention';
export function Checkbox(_a) {
    var { id, name, label, hint, disabled = false, error, warning, onChange, value, options, labelProps, hintProps } = _a, props = __rest(_a, ["id", "name", "label", "hint", "disabled", "error", "warning", "onChange", "value", "options", "labelProps", "hintProps"]);
    if (error && warning) {
        throw new Error('Cannot assign both error and warning properties, must choose one or the other.');
    }
    if (typeof value === 'boolean' && options.length !== 1) {
        throw new Error('Setting a boolean as value is only accepted when you have set single option only');
    }
    const labelId = `${id}-radio-label`;
    const errorId = `${id}-radio-error`;
    const warningId = `${id}-radio-warning`;
    const ariaLabelledBy = `${labelId} ${warningId} ${errorId}`;
    const handleChange = (event) => {
        var _a, _b;
        const internalDisabled = disabled || ((_b = (_a = event.target.attributes) === null || _a === void 0 ? void 0 : _a['aria-disabled']) === null || _b === void 0 ? void 0 : _b.value) === 'true';
        if (!internalDisabled) {
            // if it is not a single checkbox
            if (typeof value !== 'boolean') {
                const nextValue = value.includes(event.target.value)
                    ? value.filter((internalValue) => internalValue !== event.target.value)
                    : [...value, event.target.value];
                const nextOptions = options.filter((internalOption) => nextValue.includes(internalOption.value));
                onChange(event, nextValue, nextOptions);
            }
            else {
                // if it is a single checkbox
                onChange(event);
            }
        }
    };
    function renderGroupLabel() {
        const attention = !!(warning || error);
        return (label && (React.createElement(CheckboxGroupLabel, Object.assign({ id: labelId, attention: attention }, labelProps), label)));
    }
    function renderHint() {
        return hint && React.createElement(Hint, Object.assign({}, hintProps), hint);
    }
    function renderOptions() {
        return options.map((option) => (React.createElement(Single, Object.assign({ key: option.id, name: name, id: option.id, label: option.label, hint: option.hint, value: option.value, checked: typeof value === 'boolean' ? value : value.includes(option.value), onChange: handleChange, disabled: disabled || option.disabled, "aria-required": option.required }, option))));
    }
    return (React.createElement(Attention, { id: errorId || warningId, visible: !!(error || warning), title: error || warning, variant: error ? 'error' : 'warning' },
        React.createElement(CheckboxBase, Object.assign({ "aria-labelledby": ariaLabelledBy, "aria-disabled": disabled, error: error, warning: warning }, props),
            renderGroupLabel(),
            renderHint(),
            renderOptions())));
}
export default Checkbox;
export { Single as SingleCheckbox };
